import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Skeleton, Stack } from "@mui/material";
import { Box } from "@mui/system";

interface Props {
  /** how many placeholder rows to draw - matches the chosen rows per page */
  rows?: number;
}

// ID, Name, Description, Missed Run, Documented, Active, Edit
const COLUMN_COUNT = 7;

/** Placeholder that mirrors CalculationTypesTable while the list is loading. */
const CalculationTypesTableSkeleton = ({ rows = 10 }: Props) => {
  return (
    <Paper sx={{ mt: 2, boxShadow: "none" }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
                <TableCell key={index} align="left">
                  <Skeleton width={90} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                    padding: "10px 16px",
                  },
                }}
              >
                {Array.from({ length: COLUMN_COUNT }).map((__, cellIndex) => (
                  <TableCell key={cellIndex} align="left">
                    <Skeleton width="90%" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ padding: "12px 16px" }}
        >
          <Box sx={{ flex: 1 }}>
            <Skeleton width={200} height={24} />
          </Box>
          <Skeleton width={220} height={24} />
          <Box sx={{ flex: 1 }} />
        </Stack>
      </TableContainer>
    </Paper>
  );
};

export default CalculationTypesTableSkeleton;
